import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateOrderDetails } from "../../redux/reducer/shipandShopOrdersReducer"; // Adjust the path
import { useTranslation } from "react-i18next";

const RepackagingPopup = ({ order, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.shipAndShop);

  const [repackagingData, setRepackagingData] = useState({
    orderNumber: order.orderNumber,
    zone: order.zone || "",
    weight: order.weight || 0,
    status: order.status || { en: "Repackaging", ar: "إعادة التغليف" },
    images: order.images || [],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRepackagingData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateOrderDetails({ orderId: order._id, updateData: { repackagingItems: [repackagingData] } }));
    onClose(); // Close the popup after submission
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-1/3 p-6 bg-white rounded-lg shadow-lg">
        <h2 className="mb-4 text-xl font-bold text-black">{t("Repackage Order")}</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700">{t("Zone")}</label>
            <input
              type="text"
              name="zone"
              value={repackagingData.zone}
              onChange={handleInputChange}
              className="w-full p-2 text-black border rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">{t("Weight")}</label>
            <input
              type="number"
              name="weight"
              value={repackagingData.weight}
              onChange={handleInputChange}
              className="w-full p-2 text-black border rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">{t("Status (English)")}</label>
            <input
              type="text"
              name="status.en"
              value={repackagingData.status.en}
              onChange={(e) =>
                setRepackagingData((prev) => ({
                  ...prev,
                  status: { ...prev.status, en: e.target.value },
                }))
              }
              className="w-full p-2 text-black border rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">{t("Status (Arabic)")}</label>
            <input
              type="text"
              name="status.ar"
              value={repackagingData.status.ar}
              onChange={(e) =>
                setRepackagingData((prev) => ({
                  ...prev,
                  status: { ...prev.status, ar: e.target.value },
                }))
              }
              className="w-full p-2 text-black border rounded"
            />
          </div>
          <div className="flex justify-end gap-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-white bg-gray-500 rounded"
            >
              {t("cancel")}
            </button>
            <button
              type="submit"
              className={`${
                loading ? "bg-gray-400" : "bg-blue-500"
              } text-white px-4 py-2 rounded`}
              disabled={loading}
            >
              {loading ? t("Processing...") : t("Repackage")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RepackagingPopup;
